module.exports = __webpack_public_path__ + "img/peoples.5306c4f4.png";